import cx from 'classnames';
import React from 'react';

import styles from './styles.css';
import Box, { BoxProps } from '../Box';

export interface StatusLabelProps extends BoxProps {
  colored?: boolean;
}

const StatusLabel: React.FC<StatusLabelProps> = ({ colored, className, ...rest }) => {
  const classNames = cx(styles['status-label'], { [styles['status-label--colored']]: colored }, className);
  return <Box element="span" className={classNames} {...rest} />;
};

export default StatusLabel;
